import types from '../types'
import {
  getAuth,
  signInWithEmailAndPassword,
  // setPersistence,
  // browserSessionPersistence, /* broken? */
} from 'firebase/auth'
import firebase from 'firebase/compat/app'
import {signOut} from './signOut'

export const signIn = (signInForm, database) => (dispatch) => {
  const {username, password, isSaveCred} = signInForm
  const auth = getAuth()
  if (!password || !username) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        userMessage: 'Please include email and password',
      },
    })
  } else {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: true,
      },
    })
    const persistence = isSaveCred ? 'LOCAL' : 'NONE'
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence[persistence])
        .then(() => {
          signInWithEmailAndPassword(auth, username, password)
              .then((user) => {
                checkPasswordIsAccessCode(user.user, password)
                    .then((passwordIsAccessCode) => {
                      if (passwordIsAccessCode) {
                        dispatch(signOut())
                        throw new Error('used access code as password')
                      }
                    })
                    .catch(signInFailureCB)
              })
              .catch(handleMFA)
              .catch(signInFailureCB)
        })
        .catch((error) => console.log(error))
  }

  /*
    If an error related to MFA is thrown, this handles the logic
      to send and accept an MFA code
  */

  function handleMFA(error) {
    if (error.code === 'auth/multi-factor-auth-required') {
      // Notify user to look for a TOTP code
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          // directs AuthModal to switch to the MFA Tab
          onMFATab: true,
          // needed for loggin successful mfa
          // needs to be passed to the enterMFACode action for some reason
          mfaError: error,
          // had to add this or it would not stop loading
          isLoading: false,
        },
      })
      // propagate to next catch block if error isn't MFA-related
    } else throw error
  }

  /*  Response from successful signin is only stored if userData
      is successfully pulled. Userdata is stored along with signedIn/authStatus
      which triggers reroute
  */

  function signInFailureCB(response) {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: false,
        userMessage: 'Error: Failed to sign in using email and password.',
        notificationType: 3,
        notificationIcon: 'warning',
        userData: null,
      },
    })
  }

  // AccessCodes are invalid passwords on standard login page
  async function checkPasswordIsAccessCode(user, password) {
    const accessCodesRef = database.ref(`users/${user.uid}/accessCodes`)
    const passwordIsAccessCode = await accessCodesRef
        .get()
        .then((snapshot) => {
          return snapshot.val().hasOwnProperty(password)
        })
        .catch((err) => {
          return false
        })
    return passwordIsAccessCode
  }
}
